import {
    BatteryDto,
    BatterySetDto,
    EquipmentDto,
    Resource,
    RpaDto
} from '@flyfreely-portal-ui/flyfreely';
import { FormatBatterySetPipe } from './pipes/formatBatterySet.pipe';
import { FormatRpaPipe } from './pipes/formatRpa.pipe';

/**
 * Returns the name of an object of type Resource.
 */
export function findResourceName(obj: Resource, resourceType: string) {
    if (resourceType === 'CRAFT') {
        const formatRpaPipe = new FormatRpaPipe();
        return formatRpaPipe.transform(obj as RpaDto);
    }
    if (resourceType === 'BATTERY') {
        const battery = obj as BatteryDto;
        return battery.name;
    }
    if (resourceType === 'BATTERY_SET') {
        const formatBatterySet = new FormatBatterySetPipe();
        return formatBatterySet.transform(obj as BatterySetDto);
    }
    if (resourceType === 'EQUIPMENT') {
        const equipment = obj as EquipmentDto;
        return equipment.name;
    }
}
